export default __webpack_public_path__ + "static/media/NadiaLe.f2c20463.jpg";